var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArretePeril(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1544_475)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.7894 30.8192L17.7683 0.776974C17.4875 0.285607 17.0663 0.00488281 16.5048 0.00488281C15.9433 0.00488281 15.452 0.285673 15.2414 0.776974L0.150099 31.0298C-0.060477 31.451 -0.060477 31.9423 0.220313 32.3635C0.501104 32.7144 0.922256 32.9952 1.41356 32.9952H31.5962C32.3683 32.9952 33 32.3635 33 31.5914C32.9999 31.3105 32.9298 31.0298 32.7894 30.8192ZM3.58947 30.2577L16.5048 4.42698L29.35 30.2577H3.58947Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.453 20.7822C19.3126 20.361 18.9616 20.0803 18.6107 19.9399L16.8559 19.3082L18.6808 16.0793C19.0318 15.3774 18.7511 14.5351 18.1193 14.1841C17.4174 13.8332 16.5751 14.114 16.2241 14.7457L13.627 19.4486C13.4164 19.7995 13.4164 20.2207 13.5568 20.5717C13.6972 20.9226 14.0482 21.2034 14.3991 21.3438L16.1539 21.9053L13.627 26.3274C13.2059 27.0293 13.4866 27.8716 14.1184 28.2226C14.329 28.3629 14.6097 28.4332 14.8203 28.4332C15.3117 28.4332 15.803 28.1524 16.0136 27.7312L19.3828 21.9053C19.5934 21.5544 19.5934 21.1332 19.453 20.7822Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1544_475"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArretePeril);
export default __webpack_public_path__ + "static/media/icon-arrete-peril.3cd0ba8303682e32f5ae506877ab30b8.svg";
export { ForwardRef as ReactComponent };